import { IAppState } from '@/@types'

const state: IAppState = {
  isAppLoading: true,
  subscriptionsViewSelected: 'individuals',
  isComponentLoading: false,
  appErrors: [],
  appNotifications: [],
  appSuccesses: [],
  appWarnings: [],
  isPaymentModalShown: false,
  isPaymentSelectorModalShown: false,
  isEditModalShown: false,
  isSignInModalShown: false,
  isPremiumMonthlyPromoActive: false, // set to true to activate PremiumMonthly banner and styles across components
  isEDAPremiumPreSaleActive: false, // set to true to activate EDA Premium Pre-Sale banner and styles across components
  isMFAFormShown: false,
  isLoadingCaptcha: false,
  showGenericBackground: false,
}

export default state
